import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import ConvertToString, { getClassName } from "../../../components/Converter";
import RenderFor, { BM_TYP } from "../../../components/RenderFor";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";
import { decimalSeparator, thousandSeparator } from "../../../i18n";
import {
  selectTeilsicherheitsbeiwert,
  setTeilsicherheitsbeiwertStahltragglied,
} from "../../../store/slices/innereSlice";

function TeilsicherheitsbeiwertStahltragglied() {
  const { t, i18n } = useTranslation("translation");
  const dispatch = useDispatch();

  const teilsicherheitsbeiwertStahltragglied = useSelector(selectTeilsicherheitsbeiwert);

  return (
    <RowBody
      titleValue={<p>{t("inner.verificationCapacity.partialSafetyFactor")}</p>}
      indicesValue={
        <span>
          &gamma;<sub>M</sub>
        </span>
      }
      inputValue={
        <>
          <RenderFor types={[BM_TYP.EUROCODE_7]}>
            <NumberFormat
              data-testid="input-partial-safety-factor"
              className={getClassName(teilsicherheitsbeiwertStahltragglied)}
              value={teilsicherheitsbeiwertStahltragglied}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              displayType="input"
              type="text"
              onValueChange={(value) => {
                dispatch(setTeilsicherheitsbeiwertStahltragglied(value.floatValue));
              }}
              allowNegative={true}
            />
          </RenderFor>

          <RenderFor types={[BM_TYP.GERMANY]}>
            <span className="input">
              {ConvertToString(teilsicherheitsbeiwertStahltragglied, 2)}
            </span>
          </RenderFor>
        </>
      }
      formulaValue={
        <>
          <RenderFor types={[BM_TYP.GERMANY]}>
            <ToolTip
              id={"PartialSafetyFactor"}
              type={IconType.INFO}
              text={t("aeussre.partialSafetyFactorInfo")}
            />
          </RenderFor>{" "}
        </>
      }
    />
  );
}

export default TeilsicherheitsbeiwertStahltragglied;
